<template>
  <div v-if="allData.length">
    <div style="margin-top: 200px;" v-if="pathLogo == m "></div>

    <div id="table" ref="word">

      <div style="text-align: center;">
        <img  class="wlogo" :src="pathLogo" />
       </div>

      <h2 class="text-center">قسم شؤون الموظفين والتدريب</h2>
      <h3 class="text-center">
        المتغيرات الشهرية لشهر
        {{ monthDate | moment("MMMM") | localeMonth }} لسنة
        {{ monthDate | moment("YYYY") }} م
      </h3>

      <div class="grid-container-all">
        <div class="grid-container">
          <div class="grid-col-grid-col-1">ت</div>
          <div class="grid-col-grid-col-2">الرقم المالى</div>
          <div class="grid-col-grid-col-3">اسم الموظف</div>
          <div class="grid-col-grid-col-4">نهاية الندب والتعاون</div>
          <div class="grid-col-grid-gol-5">
            <div class="grid-col-5-row-1">
              المتغيرات الشهرية من
              {{ monthDate | moment("subtract", "1 month", "21 / MM / YYYY") }}
              إلى
              {{ monthDate | moment("20 / MM / YYYY") }}
            </div>
            <div class="grid-col-5-row-2">
              <div class="grid-col-5-row-2-col-1">الغياب</div>
              <div class="grid-col-5-row-2-col-2">إجازة مرضية</div>
              <div class="grid-col-5-row-2-col-3">إجازة طارئة</div>
              <div class="grid-col-5-row-2-col-4">
                <div class="grid-col-5-row-2-col-4-row-1">إجازة سنوية</div>
                <div class="grid-col-5-row-2-col-4-row-2">
                  <div class="grid-col-5-row-2-col-4-row-2-c-1">المدة</div>
                  <div class="grid-col-5-row-2-col-4-row-2-c-2">من</div>
                  <div class="grid-col-5-row-2-col-4-row-2-c-3">إلى</div>
                  <div class="grid-col-5-row-2-col-4-row-2-c-4">
                    خصم الإجازة الثانوية
                  </div>
                </div>
              </div>
              <div class="grid-col-5-row-2-col-5">س إضافى عادى</div>
              <div class="grid-col-5-row-2-col-6">س إضافى ممتاز</div>
            </div>
          </div>
        </div>
        <div class="body-container" v-for="(item, i) in allData" :key="i">
          <div class="c-1">{{ i + 1 }}</div>
          <div class="c-2">{{ item.financialNumber }}</div>
          <div class="c-3">{{ item.fullName }}</div>
          <div class="c-4">{{ convert(item.delegationEndDate || "") }}</div>
          <div class="c-5">
            <div class="c-5-c-1">{{ item.abcense }}</div>
            <div class="c-5-c-2">{{ item.sickVacation }}</div>
            <div class="c-5-c-3">{{ item.emergencyVacation }}</div>
            <div class="c-5-c-4">
              <div class="c-5-c-4-c-1">{{ item.yearlyVacationDuration }}</div>
              <div class="c-5-c-4-c-2" v-if="item.yearlyVacationDates.length">
                <span v-for="(x, i) in item.yearlyVacationDates" :key="i">
                  {{ x.from | moment("MM-DD") }}
                </span>
              </div>
              <div class="c-5-c-4-c-2" v-else>-</div>
              <div class="c-5-c-4-c-3" v-if="item.yearlyVacationDates.length">
                <span v-for="(x, i) in item.yearlyVacationDates" :key="i">
                  {{ x.to | moment("MM-DD") }}
                </span>
              </div>
              <div class="c-5-c-4-c-3" v-else>-</div>
              <div class="c-5-c-4-c-4">
                <span
                  style="width: 20%"
                  v-for="(x, i) in item.abcenseDates"
                  :key="i"
                >
                  {{ x | moment("DD") }}
                  <span v-if="i != item.abcenseDates.length - 1">,</span>
                </span>
              </div>
            </div>
            <div class="c-5-c-5">{{ item.normalOvertime }}</div>
            <div class="c-5-c-6">{{ item.excellentOvertime }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 import env from "../../../env";

export default {
  props: ["allData", "monthDate","pathLogo"],
  data() {
    return {
      m:env.mTop(),

    };
  },
  filters: {
    localeMonth(value) {
      switch (value) {
        case "January":
          return "يناير";
          break;
        case "February":
          return "فبراير";
          break;
        case "March":
          return "مارس";
          break;
        case "April":
          return "أبريل";
          break;
        case "May":
          return "مايو";
          break;
        case "June":
          return "يونيو";
          break;
        case "July":
          return "يوليو";
          break;
        case "August":
          return "أغسطس";
          break;
        case "September":
          return "سبتمبر";
          break;
        case "October":
          return "أكتوبر";
          break;
        case "November":
          return "نوفمبر";
          break;
        case "December":
          return "ديسيمبير";
          break;
        default:
          break;
      }
      return;
    },
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/monthly-variables.scss";
@import "../../assets/scss/monthly-variables-body.scss";
.span-block {
  display: block;
}
</style>